import { syncHistoryWithStore } from 'react-router-redux'
import { browserHistory } from 'react-router'
import configureStore from '../store/configureStore';


export const TOKEN_KEY = 'token';
export const USER_KEY = 'user';


export const CARGO_OPERATION_LOAD_KEY = 'LOAD';
export const CARGO_OPERATION_DISCHARGE_KEY = 'DISCHARGE';

export const store = configureStore();
export const history = syncHistoryWithStore(browserHistory, store);



// WEBPACK FOOTER //
// ./src/constants/common.js